<template>
    <div
      id="ar-button"
      v-ripple
      class="px-3 py-1 my-6 elevation-2 d-flex"
      :style="getColor"
      @click="handleClick"
    >
        <span
          class="text-subtitle-2 text--white"
          style="white-space:nowrap;"
        >
          
          {{ $vuetify.locale.t('$vuetify.seeinar') }}
        </span>
        <img
          :src="require('@/assets/ar-white.png')"
          class="ml-2"
          :style="$vuetify.display.mdAndUp ? '20' : '16'"
          :height="$vuetify.display.mdAndUp ? '20' : '16'"
        />
    </div>
</template>
<script>
    import { useLocale } from 'vuetify'
    export default {
        name: 'ArButton',
        setup () {
          const { t } = useLocale()
          return {
            t
          }
        },
        emits: ["arClick"],

        data () {
          return {
            isSelected: false
          }
        },

        props: {
          changeColor: Boolean
        },

        computed: {
          getColor () {
            if(this.isSelected) return "background: #005686 !important"
            return "background: #7CA3BB !important"
          }
        },

        watch: {
          changeColor: function(isSelected) {
            this.isSelected = isSelected
          }
        },

        methods: {
          handleClick () {
            this.isSelected = true
            this.$emit('arClick')
          },
        }

    }
</script>
<style scoped>
#ar-button {
    position: absolute;
    left: 50%;
    bottom: 0;
    align-items: center;
    transform: translateX(-50%);
    border-radius: 9999px;
    color: #fff;
    width: fit-content;
    cursor: pointer;
    z-index: 1;
}
</style>
